module.exports = __webpack_public_path__ + "img/19176134.fa9d904d.png";